<template>
  <div class="content">
    <Topbar ref="topbar" />
    <div class="m-auto breadcrumb-container" style="padding-top: 30px; padding-bottom: 30px;">
      <Breadcrumb ref="breadcrumb" :title="'公告详情'" />
    </div>
    <div class="m-auto news details-text">
      <div class="news-title" >{{ detailsInfo.name }}</div>
      <div class="news-marks">
        <div class="news-label size-16">
          <div >{{ detailsInfo.createTime | fmDate }}</div>
        </div>
        <div class="flex justify-between text-#909099 size-16" >
          <div class="newstext-size">
            字号:
            <div class="size-small" :class="fontSize === 'small' ? 'news-size' : ''" @click="fontSize = 'small'">
              小
            </div>
            <div class="size-middle" :class="fontSize === 'middle' ? 'news-size' : ''" @click="fontSize = 'middle'">
              中
            </div>
            <div class="size-big" :class="fontSize === 'big' ? 'news-size' : ''" @click="fontSize = 'big'">
              大
            </div>
          </div>
        </div>
      </div>
      <div class="mb-40px">
        <div v-if="fontSize === 'small'" class="text-html text-html-small p-line-height" style="font-size: 16px"
          v-html="detailsInfo.content"></div>
        <div v-else-if="fontSize === 'middle'" class="text-html text-html-middle p-line-height" style="font-size: 18px"
          v-html="detailsInfo.content"></div>
        <div v-else class="text-html text-html-big p-line-height" style="font-size: 20px" v-html="detailsInfo.content">
        </div>
        <div v-if="
          detailsInfo.video &&
          (detailsInfo.content === null ||
            detailsInfo.content === '' ||
            detailsInfo.content.indexOf('video') === -1)
        ">
          <Video style="width: 100%" @hidden="hiddenTitle" :src="detailsInfo.m4v" :poster="detailsInfo.picLinks"
            left="45%" bottom="45%" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { getDetail } from '@/api/home/cmsIndex.js'

export default {
  name: "NewsDetail",
  components: {
    Breadcrumb,
    // Video 组件假设已全局注册，如未注册需在此引入
  },
  data() {
    return {
      query: {},
      detailsInfo: {},
      fontSize: "middle",
    };
  },
  created() {
    this.query = this.$route.query;
    this.$nextTick(() => {
      if (this.$refs.breadcrumb) {
        this.$refs.breadcrumb.show("details");
      }
    });
    
    this.getDataInfo({
      id: this.query.id,
    });
  },
  methods: {
    async getDataInfo(info) {
      const data = await getDetail(info);
      this.detailsInfo = data;
    },
    hiddenTitle() {
      // 空方法，保留原逻辑
    },
  },
};
</script>

<style scoped lang="scss">
@import "./text.css";
.breadcrumb-container {
  width: 74%;
}

.content {

  // margin-top: 152px;
  // padding-top: 50px;
  .news {
    //   margin: 15px 80px 100px 0;

    /* width: 71.5%; */
    .news-title {
      text-align: center;
      font-weight: bold;
      margin: 0 auto;
      color: var(--basics-color-black);
      line-height: 52px;
      font-size: 40px;

      h5 {
        font-size: 18px !important;
        color: #666 !important;
        font-weight: normal !important;
      }
    }

    .news-marks {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      font-weight: 400;
      height: 42px;
      margin-bottom: 30px;
      border-bottom: 1px solid #e2e2e2;

      .news-size {
        width: 25px;
        height: 25px;
        background: #213547;
        border-radius: 50%;
        color: #ffffff;
      }

      .news-label {
        width: 200px;
        display: flex;
        gap: 30px;
        height: 15px;
        font-weight: 400;
        color: var(--basics-color-999999);
      }

      .newstext-size {
        width: 200px;
        color: var(--basics-color-999999);
        display: flex;
        gap: 20px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.details-text {
  width: 74%;
}

@media screen and (max-width: 1024px) { 
  .news-title {
    font-size: 36px !important
  }
  .details-text {
    width: 80%;
  }
  .breadcrumb-container {
    width: 80%;
  }
}
@media screen and (max-width: 768px) { 
  .news-title {
    font-size: 28px !important;
  }
  .details-text {
    width: 90%;
  }
  .breadcrumb-container {
    width: 90%;
  }
}
</style>
